import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { AMOR_MERECIMIENTO_NAME, AMOR_MERECIMIENTO_STEPS } from './combo-config'

const AmorYMerecimiento = () => (
    <ComboWizard
        comboName={AMOR_MERECIMIENTO_NAME}
        steps={AMOR_MERECIMIENTO_STEPS}
        bgClass="bg-amor-merecimiento"
        interpretStep={interpretStep}
        consultaPlaceholder="Inquietud del consultante sobre amor, pareja o merecimiento (opcional). Se usará en las 3 tiradas del combo."
    />
)

export default AmorYMerecimiento
